/**
 * App Settings
 */
import { currencies, currencyUnicode } from "../assets/data/currencydata";

//data
import { languages } from "../assets/data/localeData";

//action types
import {
   CHANGE_CURRENCY,
   HIDE_ALERT,
   SET_LANGUAGE,
   SHOW_ALERT,
   SET_ACCESS_TOKEN,
   SET_ERROR,
   SET_USER_DATA,
} from "../actions/types";

//app config
import AppConfig from "../constants/AppConfig";

const INITIAL_STATE = {
   currencies,
   selectedCurrency: currencies[1],
   currencyUnicode,
   languages,
   selectedLocale: AppConfig.locale,
   showAlert: false,
   alertType: 'success',
   alertMessage: 'Initial Message',
   accessToken: null,
   isAuthenticated: false,
   user: null,
   errors: null,
}

export default (state = INITIAL_STATE, action) => {
   switch (action.type) {
      case CHANGE_CURRENCY:
         return {
            ...state,
            selectedCurrency: action.payload
         }
      case SET_LANGUAGE: {
         return {
            ...state,
            selectedLocale: action.payload
         }
      }
      case SHOW_ALERT:
         return {
            ...state,
            showAlert: true,
            alertMessage: action.payload.message,
            alertType: action.payload.type
         }
      case HIDE_ALERT:
         return {
            ...state,
            showAlert: false
         }
      case SET_ACCESS_TOKEN:
         return {
            ...state,
             accessToken: action.payload.accessToken,
             isAuthenticated: !!action.payload.accessToken
         }
      case SET_USER_DATA:
         return {
            ...state,
             user: action.payload,
         }
      case SET_ERROR:
         console.log('message', action.payload.message)
         return {
            ...state,
             errors: action.payload.message,
         }
      default:
         return { ...state };
   }
}


// WEBPACK FOOTER //
// ./src/reducers/appSettings.js